import React, { FC } from "react";
import { Switch as MuiSwitch, SwitchProps } from "@mui/material";

const Switch: FC<SwitchProps> = (props) => <MuiSwitch {...props} />;

export default Switch;
